<template>
<div>
  <tier-modal :tierData="tierData" v-if="tierData"></tier-modal>
  <div class="row">
    <div class="col-lg-12">
      <div class="wrapper wrapper-content animated fadeInUp" v-if="dataLoaded">
        <div class="ibox">
          <div class="ibox-title">
            <h2>{{ pyramid.name }}</h2>
            <span class="btn btn-primary btn-xs">{{ pyramid.status }}</span>
            <span class="btn btn-info btn-xs" v-if="pyramid.url.constructor === Array" :title="pyramid.url.join(', ')"><strong>{{ pyramid.url.length }} urls</strong></span>
            <span class="btn btn-info btn-xs" v-if="pyramid.blacklist.constructor === Array" :title="pyramid.blacklist.join(', ')"><strong>{{ pyramid.blacklist.length }} domains blacklisted</strong></span>
            <p>
              <span>{{ pyramid.description }}</span>
            </p>
            <div class="ibox-tools">
              <span class="btn btn-primary btn-xs" @click="pyramidModal(0)" v-if="pyramid.status === 'ACTIVE'"><i class="fa fa-plus"></i> Add Tier</span>
              <span class="btn btn-success btn-xs" @click="runPyramid" v-if="pyramid.status === 'ACTIVE'"><i class="fa fa-play"></i> Run Pyramid</span>
              <span class="btn btn-info btn-xs" @click="setStatus('PAUSED')" v-if="pyramid.status === 'RUNNING'"><i class="fa fa-pause"></i> Pause Pyramid</span>
              <span class="btn btn-info btn-xs" @click="setStatus('RUNNING')" v-if="pyramid.status === 'PAUSED'"><i class="fa fa-play"></i> Resume Pyramid</span>
              <span class="btn btn-info btn-xs" @click="loadPyramid(pyramidId)"><i class="fa fa-refresh"></i> Refresh data</span>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row m-b-sm m-t-sm">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th class="center">#</th>
                  <th>Num</th>
                  <th>Filters</th>
                  <th>Blacklist</th>
                  <th>Status</th>
                  <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="tier in pyramid.tiers" :key="tier.id">
                  <td class="project-status">
                    <span class="label label-primary">T{{ tier.level }}</span>
                  </td>
                  <td>
                    {{ tier.num }}
                  </td>
                  <td class="project-title">
                    {{ tier.filters }}
                  </td>
                  <td>
                    {{ tier.blacklist.length }} urls
                  </td>
                  <td class="project-completion">
                    <small>Completion: {{ Math.round(tier.deployments.deployed / tierDeployGoal[tier.level] * 100) }}% ({{ tier.deployments.deployed }}/{{ tierDeployGoal[tier.level] }})</small>
                    <div class="progress progress-mini">
                      <div :style="'width: '+Math.round(tier.deployments.deployed / tierDeployGoal[tier.level] * 100)+'%;'" class="progress-bar"></div>
                    </div>
                  </td>
                  <td>
                    <a href="#" class="btn btn-white btn-sm"><i class="fa fa-folder"></i> View </a>
                    <a href="#" class="btn btn-white btn-sm" @click="pyramidModal(tier.id)"><i class="fa fa-pencil"></i> Edit</a>
                    <a href="#" class="btn btn-white btn-sm" @click="removeTier(tier.id)"><i class="fa fa-remove"></i> Remove</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <deployments :placements="placements" :tiers="pTiers" v-if="dataLoaded && pTiers"></deployments>
          <button class="btn-primary pull-right" @click="getPlacements" v-if="!allPlacementsLoaded">Load more</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import TierModal from './TierModal'
import Deployments from './Deployments'
import axios from 'axios'
import { eventBus } from '../../../../main'

export default {
  name: 'Pyramid',
  data () {
    return {
      dataLoaded: false,
      pyramidId: this.$route.params.pyramidId,
      pyramid: {
        tiers: []
      },
      tierData: false,
      tierDeployGoal: {},
      tiers: 0,
      placements: [],
      pTiers: [],
      limit: 50,
      offset: 0,
      allPlacementsLoaded: false
    }
  },
  components: {
    TierModal,
    Deployments
  },
  mounted () {
    this.loadPyramid(this.$route.params.pyramidId)
    eventBus.$on('tierUpdate', () => {
      this.loadPyramid(this.$route.params.pyramidId)
    })
  },
  methods: {
    pyramidModal (id) {
      if (id !== 0) {
        this.loadTier(id)
      } else {
        this.tierData = {
          num: 0,
          blacklist: '',
          filters: {
            daFrom: 0,
            daTo: 0,
            tfFrom: 0,
            tfTo: 0,
            rdFrom: 0,
            rdTo: 0
          }
        }
      }
      $('#modal-pyramid').modal('show')
    },
    loadPyramid (id) {
      axios.get('link-pyramid/' + id)
        .then(response => {
          this.pyramid = response.data
          let prev = 1
          this.pyramid.tiers.forEach(data => {
            this.tierDeployGoal[data.level] = prev *= data.num
            this.pTiers[data.id] = data
          })
        }).then(() => {
          this.getPlacements(id)
          this.dataLoaded = true
        })
    },
    loadTier (id) {
      axios.get('link-pyramid/123/tier/' + id)
        .then(response => {
          this.tierData = response.data
        })
    },
    removeTier (id) {
      if (confirm('Delete tier?')) {
        axios.delete('link-pyramid/' + this.pyramidId + '/tier/' + id)
          .then(r => {
            this.loadPyramid(this.pyramidId)
          })
      }
    },
    runPyramid () {
      if (confirm('Really?')) {
        axios.get('link-pyramid/' + this.pyramidId + '/run')
          .then(r => {
            console.log('pyramid sorted, woo hoo')
          })
      }
    },
    setStatus (statusVal) {
      if (confirm('Really?')) {
        axios.patch('link-pyramid/' + this.pyramidId, {
          status: statusVal
        })
          .then(r => {
            this.loadPyramid(this.$route.params.pyramidId)
          })
      }
    },
    getPlacements () {
      let pyramid = this.pyramid.id
      let limit = this.limit
      let offset = this.offset
      axios.get('/link-pyramid/' + pyramid + '/deployments?limit=' + limit + '&offset=' + offset)
        .then(r => {
          r.data.data.forEach(p => {
            this.placements.push(p)
          })
          if (r.data.meta.count < limit) {
            this.allPlacementsLoaded = true
          }
        })
        .then(() => {
          this.offset += limit
        })
        .catch(e => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Apps/link-pyramid/Pyramid.vue